import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "className", "scrollable"];
import { jsx } from 'react/jsx-runtime';
import * as ToolbarPrimitive from '@radix-ui/react-toolbar';
import clsx from 'clsx';
import { forwardRef } from 'react';
import { ToolbarScrollableContainer } from './toolbar-scrollable-container.js';
import styles from './toolbar.module.js';
import { HorizontalScrollProvider } from './utils/horizontal-scroll-context.js';
var ToolbarRoot = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  var children = props.children,
      className = props.className,
      scrollable = props.scrollable,
      rest = _objectWithoutProperties(props, _excluded);

  if (scrollable) {
    var ariaLabelNextButton = props.ariaLabelNextButton,
        ariaLabelPrevButton = props.ariaLabelPrevButton,
        maxWidth = props.maxWidth,
        _props$scrollStep = props.scrollStep,
        scrollStep = _props$scrollStep === void 0 ? 50 : _props$scrollStep;
    return jsx(ToolbarPrimitive.Root, _objectSpread(_objectSpread({}, rest), {}, {
      ref: forwardedRef,
      className: clsx(styles.toolbarRoot, className),
      style: {
        maxWidth: maxWidth
      },
      children: jsx(HorizontalScrollProvider, {
        scrollStep: scrollStep,
        children: jsx(ToolbarScrollableContainer, {
          ariaLabelNextButton: ariaLabelNextButton,
          ariaLabelPrevButton: ariaLabelPrevButton,
          children: children
        })
      })
    }));
  }

  return jsx(ToolbarPrimitive.Root, _objectSpread(_objectSpread({}, rest), {}, {
    ref: forwardedRef,
    className: clsx(styles.toolbarRoot, className),
    children: children
  }));
});
export { ToolbarRoot };